import { Box, Grid, Container } from "@mui/material";

import info from "../assets/info-bg.png";

function StakingBanner({ apr, solarStaked, solarValueStaked }) {
  return (
    <Box my={8} textAlign="center">
      <Container maxWidth="lg">
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={11} sm={11} md={4}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <img style={{ position: "absolute" }} src={info} alt="" />
              <Box
                position="relative"
                height="194px"
                display="flex"
                justifyContent="center"
                flexDirection="column"
              >
                <Box fontFamily="Poppins" fontWeight={400} fontSize="14px">
                  TOTAL VALUE STAKED
                </Box>
                <Box
                  mt={2}
                  fontFamily="Poppins"
                  fontWeight={700}
                  fontSize="30px"
                >
                  ${" "}
                  {solarValueStaked
                    .toFixed(0)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={11} sm={11} md={4}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <img style={{ position: "absolute" }} src={info} alt="" />
              <Box
                position="relative"
                height="194px"
                display="flex"
                flexDirection="column"
                justifyContent="center"
              >
                <Box fontFamily="Poppins" fontWeight={400} fontSize="14px">
                  SOLAR SHEPARD STAKED
                </Box>
                <Box
                  mt={2}
                  fontFamily="Poppins"
                  fontWeight={700}
                  fontSize="30px"
                >
                  {solarStaked.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={11} sm={11} md={4}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <img style={{ position: "absolute" }} src={info} alt="" />
              <Box
                position="relative"
                height="194px"
                display="flex"
                flexDirection="column"
                justifyContent="center"
              >
                <Box fontFamily="Poppins" fontWeight={400} fontSize="14px">
                  Average APR
                </Box>
                <Box
                  mt={2}
                  fontFamily="Poppins"
                  fontWeight={700}
                  fontSize="30px"
                >
                  {apr}%
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default StakingBanner;
